import HomepageTopBannerExtends from 'gatsby-theme-husky/src/components/HomepageTopBanner/HomepageTopBanner';

import './HomepageTopBannerExtends.scss';

export default HomepageTopBannerExtends;
